/**
 * Customer-facing sales tax line labels (PBI #1515).
 * Keep in sync with ScheduledSmiles.Api.Constants.OrderTaxLineLabels.
 */
export const OrderTaxLineLabels = {
  salesTax: 'Sales tax',
  estimatedSalesTax: 'Estimated sales tax',
  calculatedAtReview: 'Sales tax: calculated at review',
  /** Total row when tax/total will not be quoted on this review surface (#1416). */
  totalCalculatedAtReview: 'Calculated at review',
} as const;
